import {
  Dialog,
  DialogBody,
  DialogContent,
  Sheet,
  SheetBody,
  SheetContent,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import { useNavigate } from "react-router-dom"
import routes from "routes"

import Content from "./Content"

const GetStarted = ({
  open,
  handleContinue,
  handleClose,
  isPendingTour,
}: {
  open: boolean
  handleContinue?: () => void
  handleClose?: () => void
  isPendingTour?: boolean
}) => {
  const navigate = useNavigate()
  const isSmDown = useMediaQuery("only screen and (max-width : 599px)")

  const startTour = () => {
    navigate(routes.learning)
    if (handleContinue) handleContinue()
  }

  if (isSmDown) {
    return (
      <Sheet open={open}>
        <SheetContent height={95} className="!p-0">
          <SheetBody className="!p-0">
            <Content
              handleClose={handleClose}
              handleContinue={startTour}
              isPendingTour={isPendingTour}
            />
          </SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="rounded-2xl  p-0">
        <DialogBody className="overflow-x-hidden p-0">
          <Content
            handleClose={handleClose}
            handleContinue={startTour}
            isPendingTour={isPendingTour}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default GetStarted
